import { useSplitTestBranch } from '@api/lendingAPI/lapiHooks';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { Spinner } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import { connect } from 'react-redux';

import {
    getTopUpStatus,
    repeatsTopUpEligibilitySplitTestName
} from '../NewOutstandingView.helpers';
import { NotTopUpEligible } from './TopUpStatusMessages/NotTopUpEligible';
import { NotYetTopUpEligible } from './TopUpStatusMessages/NotYetTopUpEligible';
import { PreApproved } from './TopUpStatusMessages/PreApproved';
import { TopUpDeclined } from './TopUpStatusMessages/TopUpDeclined';
import TopUpEligible from './TopUpStatusMessages/TopUpEligible';
import { TopUpPending } from './TopUpStatusMessages/TopUpPending';
import { TProductType } from '../../../dashboard/Dashboard.types';

const mapStateToProps = (state: RootState, { productType }: TProps) => {
    return {
        topUpStatus: getTopUpStatus(state, productType)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps>;
type TProps = { accountId: string; productType: TProductType };

const RequestMoreFundsPanel = ({
    topUpStatus,
    accountId
}: TProps & PropsFromRedux) => {
    const isUK = getCountry() === 'UK';

    const { branch, isLoading } = useSplitTestBranch({
        test: repeatsTopUpEligibilitySplitTestName,
        suspense: false
    });

    if (isLoading) {
        return (
            <div className="flex justify-center">
                <Spinner size="large" />
            </div>
        );
    }

    const inFirstRepaymentTest = branch === 'INCLUDE';

    switch (topUpStatus) {
        case 'NOT_YET_TOPUP_ELIGIBLE':
            if (isUK && !inFirstRepaymentTest) return <NotTopUpEligible />;
            return <NotYetTopUpEligible accountId={accountId} />;
        case 'TOPUP_ELIGIBLE':
            return <TopUpEligible accountId={accountId} />;
        case 'TOPUP_PENDING':
            return <TopUpPending />;
        case 'TOPUP_DECLINED':
            return <TopUpDeclined />;
        case 'PRE_APPROVED':
            return <PreApproved accountId={accountId} />;
        default:
            return <NotTopUpEligible />;
    }
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(RequestMoreFundsPanel);
